const theme_black = {
  id: 3,
  name: "black",
  displayName: "Pitch Black",
  themeBaseType: "dark",
  themeVariables: {
    COLORS: {
      ACCENT: "#26538D",
      SECONDARY: "#9CAFBF",
      SURFACE: "#000000",
      SURFACE_LIGHTER: "#121212",
      RECEIVE_BUBBLE: "#121212",
      BACKGROUND: "#000000",
      APP_BACKGROUND: "#000000",
      ON_ACCENT: "#FFFFFF",
      ON_SURFACE: "#FFFFFF",
      ON_BACKGROUND: "#FFFFFF",
    },
    BUTTON: {
      BORDER_RADIUS: "25px",
      SHADOW: "0 0 16px 0px rgba(0, 0, 0, 0.3)",
    },
    CONTAINER: {
      BORDER_RADIUS: "12px",
      SHADOW: "0px 0px 13px 1px rgba(0, 0, 0, 0.1)",
    },
    LIST: {
      BORDER_RADIUS: "15px",
    },
  },
};

export default theme_black;
